<!--课程业务-->
<template>
  <div  class="app-container">
    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="warning" size="medium" class="operator-btn2" style="margin-right: 0px;" icon="el-icon-circle-plus-outline" @click="handleCreateOneDlg()">新增</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        ref="seleteTable"
        v-loading="listLoading"
        border>
        <el-table-column type="selection" width="200"></el-table-column>
        <el-table-column prop="cancleBookReason" label="取消预约原因"></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button @click="handleDeleteOneDlg(scope.row)" type="warning"  size="mini" icon="el-icon-delete" plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="visibleDlgAdd"
      width="50%"
      center>
      <el-form ref="registerRef"  label-width="150px">
        <el-form-item label="取消原因:" >
          <el-input v-model="createParam.cancleBookReason" placeholder="" style="width: 450px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../utils/globaldata";
  import {addReason, delReason, selectall} from "../../api/cancelBookReason";
  import commonUtils from "../../utils/commonUtils";
  import messageUtils from "../../utils/messageUtils";
  import {delLevelLesson} from "../../api/StoreLevelLesson";

  export default {
    data() {
      return {
        listLoading: true,
        visibleDlgAdd:false,

        //表单结果
        tableData: [
        ],

        createParam :{
          cancleBookReason :'',
        },
        deleteParam :{
          cancleBookReason :'',
        }

      }
    },
    mounted() {
      this.fetchList();
    },
    methods: {

      fetchList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        selectall(param).then(response => {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.refreshData(date);
        })
      },

      //刷新页面数据
      refreshData(list){
        if (commonUtils.isObjectNull(list)){
          return;
        }
        let tableDataList = [];
        for (let i = 0;i< list.length;++i){
          let data = {
            number : i+1 ,
            id: list[i].id,
            cancleBookReason:list[i].reason,
          };
          tableDataList.push(data);
        }
        this.tableData = tableDataList;
      },

      handleDeleteOneDlg(row){
        this.deleteParam = {
          id :row.id,
          cancleBookReason :row.cancleBookReason
        }
        let that = this;
        this.$confirm('是否要删除取消预约原因为：'+ row.cancleBookReason +' 的原因?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
          that.handleDeleteOne();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });



        this.visibleDlgDelete = true;
      },
      handleDeleteOne(){
        let param = {
          id : this.deleteParam.id,
        }
        delReason(param).then(response =>
        {
          let date = response.data;
          if (date == true){
            messageUtils.successMsg(this,response.message);
            this.fetchList();
            this.visibleDlgDelete = false;
          }else {
            messageUtils.errorMsg(this,response.message);
          }
        })
      },
      //添加
      handleCreateOneDlg(){
        this.visibleDlgAdd = true;
      },
      handleCreateOne(){
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          reason : this.createParam.cancleBookReason
        }
        addReason(param).then(response =>
        {
          let date = response.data;
          if (!commonUtils.isObjectNull(date)){
            messageUtils.successMsg(this,response.message);
            this.visibleDlgAdd = false;
            this.fetchList();
          }else {
            messageUtils.errorMsg(this,response.message)
          }
        })
      }

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/cancel-book-reason/index.vue